/* eslint-disable import/no-named-as-default-member */
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@athwab/shared';
import i18nextInstance, { type i18n as I18nInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import adminAr from './resources/ar/admin.json';
import assistantAr from './resources/ar/assistant.json';
import authAr from './resources/ar/auth.json';
import billingAr from './resources/ar/billing.json';
import commonAr from './resources/ar/common.json';
import marketingAr from './resources/ar/marketing.json';
import settingsAr from './resources/ar/settings.json';
import studioAr from './resources/ar/studio.json';
import workspaceAr from './resources/ar/workspace.json';
import adminEn from './resources/en/admin.json';
import assistantEn from './resources/en/assistant.json';
import authEn from './resources/en/auth.json';
import billingEn from './resources/en/billing.json';
import commonEn from './resources/en/common.json';
import marketingEn from './resources/en/marketing.json';
import settingsEn from './resources/en/settings.json';
import studioEn from './resources/en/studio.json';
import workspaceEn from './resources/en/workspace.json';

const resources = {
  en: {
    common: commonEn,
    marketing: marketingEn,
    auth: authEn,
    admin: adminEn,
    billing: billingEn,
    settings: settingsEn,
    studio: studioEn,
    assistant: assistantEn,
    workspace: workspaceEn
  },
  ar: {
    common: commonAr,
    marketing: marketingAr,
    auth: authAr,
    admin: adminAr,
    billing: billingAr,
    settings: settingsAr,
    studio: studioAr,
    assistant: assistantAr,
    workspace: workspaceAr
  }
} as const;

let initializationPromise: Promise<I18nInstance> | null = null;

export const LOCAL_STORAGE_LOCALE_KEY = 'athwab_locale';

export const initI18n = () => {
  if (!initializationPromise) {
    initializationPromise = i18nextInstance
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources,
        supportedLngs: SUPPORTED_LOCALES.map((locale) => locale.id),
        fallbackLng: DEFAULT_LOCALE,
        ns: ['common', 'marketing', 'auth', 'admin', 'billing', 'settings', 'studio', 'assistant', 'workspace'],
        defaultNS: 'common',
        load: 'currentOnly',
        lowerCaseLng: true,
        cleanCode: true,
        nonExplicitSupportedLngs: true,
        interpolation: {
          escapeValue: false
        },
        detection: {
          order: ['localStorage', 'htmlTag', 'navigator'],
          lookupLocalStorage: LOCAL_STORAGE_LOCALE_KEY,
          caches: ['localStorage']
        },
        returnNull: false,
        react: {
          useSuspense: false
        }
      })
      .then(() => i18nextInstance);
  }

  return initializationPromise;
};

export default i18nextInstance;
